import { isEmpty, isNull, isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, useLocation, } from 'react-router-dom';
import useAuth from '../controllers/users/useAuth';
import { globalSettings, responseGet, sendMessage } from '../helpers/settings';

export default function PrivateRoute({ component: Component, ...rest }) {
    //#region variables

    const location = useLocation();
    const auth = useAuth();
    const [isUserLoged, setIsUserLoged] = useState(auth?.isLoged());

    //#endregion variables

    //#region methods

    const localDataGet = () => {
        let response = responseGet();
        try {
            if (isUndefined(auth.user) || isNull(auth.user) || isEmpty(auth.user) ||
                isUndefined(auth.user.tokenVzLaCondominios) || isNull(auth.user.tokenVzLaCondominios) || isEmpty(auth.user.tokenVzLaCondominios) ||
                isUndefined(auth?.user?.tokenVzLaCondominios?.token) || isNull(auth?.user?.tokenVzLaCondominios?.token) || isEmpty(auth?.user?.tokenVzLaCondominios?.token)) {
                setIsUserLoged(false);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: localDataGet<br/>`;
            response.msgText += `Error: ${ex?.message}`;
            sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
        }
    }

    useEffect(() => {
        localDataGet();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods

    return (
        <Route {...rest}>
            {/* {auth?.isLoged() ? (<Component />) : (<Redirect to={{ pathname: globalSettings?.app?.backend?.urlLogin, state: { from: location } }} />)} */}
            {isUserLoged ? (<Component />) : (<Redirect to={{ pathname: globalSettings?.app?.backend?.urlLogin, state: { from: location } }} />)}
        </Route>
    )
}